let products = {
    init: function () {
        products.toggle();
        products.headerHeightAdjustments();
    },

    toggle: function () {
        $(document).on('click', '.products__filters__items a', function (e) {
            e.preventDefault();

            let $this = $(this),
                activeFilter = $this.attr('data-filter');
            $('.products__filters__items a').removeClass('active');
            $this.addClass('active');

            if (activeFilter === 'all') {
                $('.products__grid__item').show();
            } else {
                $('.products__grid__item').each(function () {
                    let $that = $(this);
                    if (!$that.hasClass(activeFilter)) {
                        $that.hide();
                    } else {
                        $that.show();
                    }
                });

                $('.category_description').removeClass('active');

                $('.category_description').each(function () {
                    let $data = $(this).data('filter');
                    if (activeFilter === $data) {
                        $(this).addClass('active');
                    }
                });
            }
        });
    },

    headerHeightAdjustments: function () {
        let $productSubtitleHeaders = $('.page-template-template-products .category__grid__item .has-subtitle');
        let maxHeight = 0;

        // find tallest then set them all to that height for design consistency
        $productSubtitleHeaders.each(function () {
            let $this = $(this);

            if (Math.ceil($this.outerHeight()) > maxHeight) {
                maxHeight = Math.ceil($this.outerHeight());
            }
        });

        $('.page-template-template-products .category__grid__item h3').css('height', maxHeight);
    },
};

$(document).ready(function () {
    products.init();
});
